// // import React, { useState, useEffect, useContext } from 'react';
// // import { postData, serverURL } from '../../../../services/Fetchnodeservices';
// // import { X, Save, Sparkles, Trash2 } from 'lucide-react';
// // import ImageSearchModal from './ImageSearchModal';
// // // ⚠️ IMPORTANT: Adjust this path to exactly match where your ThemeContext is located!
// // import { ThemeContext } from '../../../../context/ThemeContext';

// // const EditItemModal = ({ isOpen, onClose, item, designationId, onUpdate, ts }) => {
// //     // 🛡️ SAFE CONTEXT CONSUMPTION WITH FALLBACK
// //     const themeContext = useContext(ThemeContext);
// //     const isDarkMode = themeContext?.currentTheme === 'dark';
    
// //     const fallbackTheme = {
// //         background: isDarkMode ? "#0a0e1a" : "#f8fafc",
// //         surface: isDarkMode ? "#1e293b" : "#ffffff",
// //         surfaceLighter: isDarkMode ? "#0f172a" : "#f1f5f9",
// //         border: isDarkMode ? "#334155" : "#e2e8f0",
// //         textPrimary: isDarkMode ? "#f8fafc" : "#0f172a",
// //         textSecondary: isDarkMode ? "#94a3b8" : "#64748b",
// //         textMuted: isDarkMode ? "#64748b" : "#94a3b8",
// //         primary: "#6366f1",
// //         primaryLight: "rgba(99, 102, 241, 0.15)",
// //         gradientCard: isDarkMode ? "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)" : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
// //         success: "#22c55e",
// //         error: "#ef4444",
// //     };

// //     // Use provided ts prop or fallback to context theme
// //     const theme = ts || themeContext?.theme || fallbackTheme;

// //     const [formData, setFormData] = useState(null);
// //     const [saving, setSaving] = useState(false);
// //     const [showImageFinder, setShowImageFinder] = useState(false);

// //     useEffect(() => {
// //         if (item) {
// //             // Parse variants safely
// //             let variants = [];
// //             try {
// //                 variants = Array.isArray(item.variant) ? item.variant : JSON.parse(item.variant || '[]');
// //             } catch (e) {
// //                 variants = [];
// //             }

// //             // 🔥 FIX: If actual_price is missing, set it to item_price_variant (treat as menu)
// //             const processed = variants.map(v => ({
// //                 ...v,
// //                 actual_price: v.actual_price || parseFloat(v.item_price_variant || v.price) || 0
// //             }));

// //             // Item-level fallback (if no variants, use requested_price or price)
// //             let itemLevelMenu = parseFloat(item.requested_price) || 0;
// //             if (!itemLevelMenu) {
// //                 itemLevelMenu = parseFloat(item.price) || 0;
// //             }

// //             setFormData({
// //                 ...item,
// //                 requested_price: itemLevelMenu,
// //                 price: parseFloat(item.price) || 0,
// //                 variant: processed
// //             });
// //         }
// //     }, [item]);

// //     // Customer price = menu * 1.2
// //     const calculateCustomerPrice = (menuP) => {
// //         const menu = parseFloat(menuP) || 0;
// //         return Math.round(menu * 1.20);
// //     };

// //     const handleSave = async () => {
// //         setSaving(true);
// //         try {
// //             // Process each variant: actual_price is menu, item_price_variant = menu * 1.2
// //             const finalVariants = formData.variant.map(v => {
// //                 const menuPrice = parseFloat(v.actual_price) || 0;
// //                 const custPrice = calculateCustomerPrice(menuPrice);
// //                 return {
// //                     ...v,
// //                     actual_price: menuPrice,
// //                     item_price_variant: custPrice,
// //                     price: custPrice,
// //                     unit: (v.unit_value || "Price").toLowerCase(),
// //                     is_available_variant: "yes"
// //                 };
// //             });

// //             // Item-level prices from first variant if exists
// //             let itemRequestedPrice = 0;
// //             let itemPrice = 0;
// //             if (finalVariants.length > 0) {
// //                 itemRequestedPrice = finalVariants[0].actual_price;
// //                 itemPrice = finalVariants[0].item_price_variant;
// //             } else {
// //                 itemRequestedPrice = parseFloat(formData.requested_price) || 0;
// //                 itemPrice = calculateCustomerPrice(itemRequestedPrice);
// //             }

// //             const finalItem = {
// //                 ...formData,
// //                 variant: finalVariants,
// //                 requested_price: itemRequestedPrice,
// //                 price: itemPrice,
// //                 is_veg: formData.is_veg || 'yes'
// //             };

// //             console.log('Saving item:', finalItem);

// //             const resp = await postData(`menu/update-menu/${designationId}/${item.product_id}`, finalItem, 'PUT');
// //             if (resp.success) {
// //                 onUpdate();
// //                 onClose();
// //             } else {
// //                 alert('Update failed: ' + (resp.message || 'Unknown error'));
// //             }
// //         } catch (e) {
// //             console.error('Save error:', e);
// //             alert('Error: ' + e.message);
// //         } finally { 
// //             setSaving(false); 
// //         }
// //     };

// //     if (!isOpen || !formData) return null;

// //     // Styles (using theme prop)
// //     const styles = {
// //         overlay: {
// //             position: 'fixed',
// //             inset: 0,
// //             background: 'rgba(0,0,0,0.85)',
// //             backdropFilter: 'blur(4px)',
// //             zIndex: 10000,
// //             display: 'flex',
// //             alignItems: 'center',
// //             justifyContent: 'center',
// //             padding: '20px',
// //         },
// //         modal: {
// //             background: theme.surface,
// //             width: '100%',
// //             maxWidth: '500px',
// //             borderRadius: '24px',
// //             border: `1px solid ${theme.border}`,
// //             color: theme.textPrimary,
// //             overflow: 'hidden',
// //             backgroundImage: theme.gradientCard,
// //             boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
// //             maxHeight: '90vh',
// //             display: 'flex',
// //             flexDirection: 'column',
// //         },
// //         header: {
// //             padding: '20px',
// //             borderBottom: `1px solid ${theme.border}`,
// //             display: 'flex',
// //             justifyContent: 'space-between',
// //             alignItems: 'center',
// //             background: theme.surface,
// //         },
// //         title: {
// //             margin: 0,
// //             fontSize: '20px',
// //             fontWeight: 700,
// //             color: theme.textPrimary,
// //         },
// //         closeButton: {
// //             background: theme.surfaceLighter,
// //             border: 'none',
// //             color: theme.textMuted,
// //             cursor: 'pointer',
// //             padding: '8px',
// //             borderRadius: '8px',
// //             display: 'flex',
// //             alignItems: 'center',
// //             justifyContent: 'center',
// //             transition: 'all 0.2s',
// //         },
// //         body: {
// //             padding: '24px',
// //             overflowY: 'auto',
// //             flex: 1,
// //         },
// //         input: {
// //             width: '100%',
// //             padding: '12px',
// //             borderRadius: '12px',
// //             background: theme.background,
// //             border: `1px solid ${theme.border}`,
// //             color: theme.textPrimary,
// //             marginBottom: '15px',
// //             outline: 'none',
// //             fontSize: '14px',
// //             transition: 'all 0.2s',
// //         },
// //         textarea: {
// //             width: '100%',
// //             padding: '12px',
// //             borderRadius: '12px',
// //             background: theme.background,
// //             border: `1px solid ${theme.border}`,
// //             color: theme.textPrimary,
// //             marginBottom: '15px',
// //             outline: 'none',
// //             fontSize: '14px',
// //             resize: 'vertical',
// //             minHeight: '60px',
// //             fontFamily: 'inherit',
// //             transition: 'all 0.2s',
// //         },
// //         select: {
// //             width: '100%',
// //             padding: '12px',
// //             borderRadius: '12px',
// //             background: theme.background,
// //             border: `1px solid ${theme.border}`,
// //             color: theme.textPrimary,
// //             marginBottom: '15px',
// //             outline: 'none',
// //             fontSize: '14px',
// //             cursor: 'pointer',
// //             transition: 'all 0.2s',
// //         },
// //         vRow: {
// //             display: 'flex',
// //             gap: '10px',
// //             alignItems: 'center',
// //             background: theme.surfaceLighter,
// //             padding: '12px',
// //             borderRadius: '15px',
// //             marginBottom: '10px',
// //             border: `1px solid ${theme.border}`,
// //             transition: 'all 0.2s',
// //         },
// //         variantInput: {
// //             ...styles.input,
// //             marginBottom: 0,
// //             flex: 1.5,
// //         },
// //         priceInput: {
// //             ...styles.input,
// //             marginBottom: 0,
// //             flex: 1,
// //         },
// //         priceDisplay: {
// //             flex: 1,
// //             textAlign: 'right',
// //         },
// //         priceLabel: {
// //             fontSize: '10px',
// //             color: theme.textMuted,
// //         },
// //         priceValue: {
// //             color: theme.success,
// //             fontWeight: 700,
// //             fontSize: '14px',
// //         },
// //         deleteButton: {
// //             color: theme.error,
// //             background: 'none',
// //             border: 'none',
// //             cursor: 'pointer',
// //             padding: '4px',
// //             borderRadius: '6px',
// //             display: 'flex',
// //             alignItems: 'center',
// //             justifyContent: 'center',
// //             transition: 'all 0.2s',
// //         },
// //         addButton: {
// //             color: theme.primary,
// //             background: 'none',
// //             border: 'none',
// //             fontSize: '12px',
// //             cursor: 'pointer',
// //             fontWeight: 600,
// //             padding: '4px 8px',
// //             borderRadius: '6px',
// //             transition: 'all 0.2s',
// //         },
// //         footer: {
// //             padding: '20px',
// //             borderTop: `1px solid ${theme.border}`,
// //             display: 'flex',
// //             gap: '10px',
// //             background: theme.surface,
// //         },
// //         cancelButton: {
// //             flex: 1,
// //             padding: '12px',
// //             borderRadius: '12px',
// //             border: `1px solid ${theme.border}`,
// //             background: theme.surfaceLighter,
// //             color: theme.textSecondary,
// //             cursor: 'pointer',
// //             fontWeight: 600,
// //             transition: 'all 0.2s',
// //         },
// //         saveButton: {
// //             flex: 2,
// //             padding: '12px',
// //             borderRadius: '12px',
// //             background: theme.gradient || theme.primary,
// //             color: '#fff',
// //             border: 'none',
// //             fontWeight: 700,
// //             cursor: 'pointer',
// //             transition: 'all 0.2s',
// //             display: 'flex',
// //             alignItems: 'center',
// //             justifyContent: 'center',
// //             gap: '8px',
// //         },
// //         imageContainer: {
// //             textAlign: 'center',
// //         },
// //         image: {
// //             width: '100px',
// //             height: '100px',
// //             borderRadius: '16px',
// //             objectFit: 'cover',
// //             border: `2px solid ${theme.border}`,
// //         },
// //         aiButton: {
// //             marginTop: '8px',
// //             background: theme.primary,
// //             color: '#fff',
// //             border: 'none',
// //             padding: '6px 12px',
// //             borderRadius: '8px',
// //             fontSize: '11px',
// //             fontWeight: 600,
// //             cursor: 'pointer',
// //             display: 'flex',
// //             alignItems: 'center',
// //             justifyContent: 'center',
// //             gap: '4px',
// //             transition: 'all 0.2s',
// //         },
// //         formGroup: {
// //             flex: 1,
// //         },
// //         imageSection: {
// //             display: 'flex',
// //             gap: '20px',
// //             marginBottom: '20px',
// //         },
// //         pricingHeader: {
// //             display: 'flex',
// //             justifyContent: 'space-between',
// //             alignItems: 'center',
// //             marginBottom: '10px',
// //         },
// //         pricingLabel: {
// //             fontSize: '12px',
// //             fontWeight: 700,
// //             color: theme.textPrimary,
// //             display: 'flex',
// //             alignItems: 'center',
// //             gap: '6px',
// //         },
// //     };

// //     return (
// //         <div style={styles.overlay} onClick={onClose}>
// //             <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
// //                 <div style={styles.header}>
// //                     <h3 style={styles.title}>✏️ Edit Item</h3>
// //                     <button 
// //                         onClick={onClose} 
// //                         style={styles.closeButton}
// //                         onMouseEnter={(e) => {
// //                             e.currentTarget.style.background = theme.border;
// //                             e.currentTarget.style.color = theme.textPrimary;
// //                         }}
// //                         onMouseLeave={(e) => {
// //                             e.currentTarget.style.background = theme.surfaceLighter;
// //                             e.currentTarget.style.color = theme.textMuted;
// //                         }}
// //                     >
// //                         <X size={18} />
// //                     </button>
// //                 </div>
                
// //                 <div style={styles.body}>
// //                     <div style={styles.imageSection}>
// //                         <div style={styles.imageContainer}>
// //                             <img
// //                                 src={formData.pic1?.startsWith('http') ? formData.pic1 : `${serverURL}/uploads/${formData.pic1}`}
// //                                 style={styles.image}
// //                                 alt="Item"
// //                                 onError={(e) => {
// //                                     e.target.src = "https://via.placeholder.com/100?text=No+Image";
// //                                 }}
// //                             />
// //                             <button
// //                                 onClick={() => setShowImageFinder(true)}
// //                                 style={styles.aiButton}
// //                                 onMouseEnter={(e) => {
// //                                     e.currentTarget.style.filter = 'brightness(1.1)';
// //                                     e.currentTarget.style.transform = 'translateY(-1px)';
// //                                 }}
// //                                 onMouseLeave={(e) => {
// //                                     e.currentTarget.style.filter = 'brightness(1)';
// //                                     e.currentTarget.style.transform = 'translateY(0)';
// //                                 }}
// //                             >
// //                                 <Sparkles size={12}/> AI Search
// //                             </button>
// //                         </div>
// //                         <div style={styles.formGroup}>
// //                             <input
// //                                 style={styles.input}
// //                                 value={formData.name || ''}
// //                                 onChange={(e) => setFormData({...formData, name: e.target.value})}
// //                                 placeholder="Item Name"
// //                                 onFocus={(e) => {
// //                                     e.target.style.borderColor = theme.primary;
// //                                     e.target.style.boxShadow = `0 0 0 3px ${theme.primaryLight}`;
// //                                 }}
// //                                 onBlur={(e) => {
// //                                     e.target.style.borderColor = theme.border;
// //                                     e.target.style.boxShadow = 'none';
// //                                 }}
// //                             />
// //                             <select
// //                                 style={styles.select}
// //                                 value={formData.is_veg || 'yes'}
// //                                 onChange={(e) => setFormData({...formData, is_veg: e.target.value})}
// //                                 onFocus={(e) => {
// //                                     e.target.style.borderColor = theme.primary;
// //                                     e.target.style.boxShadow = `0 0 0 3px ${theme.primaryLight}`;
// //                                 }}
// //                                 onBlur={(e) => {
// //                                     e.target.style.borderColor = theme.border;
// //                                     e.target.style.boxShadow = 'none';
// //                                 }}
// //                             >
// //                                 <option value="yes"> Veg</option>
// //                                 <option value="no">🍖 Non-Veg</option>
// //                             </select>
// //                         </div>
// //                     </div>
                    
// //                     <textarea
// //                         style={styles.textarea}
// //                         value={formData.description || ''}
// //                         onChange={(e) => setFormData({...formData, description: e.target.value})}
// //                         placeholder="Description"
// //                         rows="3"
// //                         onFocus={(e) => {
// //                             e.target.style.borderColor = theme.primary;
// //                             e.target.style.boxShadow = `0 0 0 3px ${theme.primaryLight}`;
// //                         }}
// //                         onBlur={(e) => {
// //                             e.target.style.borderColor = theme.border;
// //                             e.target.style.boxShadow = 'none';
// //                         }}
// //                     />

// //                     <div style={styles.pricingHeader}>
// //                         <label style={styles.pricingLabel}>💲 Pricing (Menu Price)</label>
// //                         <button
// //                             onClick={() => setFormData({
// //                                 ...formData,
// //                                 variant: [...formData.variant, { unit_value: '', actual_price: 0 }]
// //                             })}
// //                             style={styles.addButton}
// //                             onMouseEnter={(e) => {
// //                                 e.currentTarget.style.background = theme.primaryLight;
// //                             }}
// //                             onMouseLeave={(e) => {
// //                                 e.currentTarget.style.background = 'none';
// //                             }}
// //                         >
// //                             + Add Variant
// //                         </button>
// //                     </div>

// //                     {formData.variant.map((v, i) => (
// //                         <div 
// //                             key={i} 
// //                             style={styles.vRow}
// //                             onMouseEnter={(e) => {
// //                                 e.currentTarget.style.borderColor = theme.primary;
// //                                 e.currentTarget.style.boxShadow = `0 2px 8px ${theme.primary}20`;
// //                             }}
// //                             onMouseLeave={(e) => {
// //                                 e.currentTarget.style.borderColor = theme.border;
// //                                 e.currentTarget.style.boxShadow = 'none';
// //                             }}
// //                         >
// //                             <input
// //                                 style={styles.variantInput}
// //                                 placeholder="Unit (e.g. Half, Full)"
// //                                 value={v.unit_value || ''}
// //                                 onChange={(e) => {
// //                                     let nv = [...formData.variant];
// //                                     nv[i].unit_value = e.target.value;
// //                                     setFormData({...formData, variant: nv});
// //                                 }}
// //                                 onFocus={(e) => {
// //                                     e.target.style.borderColor = theme.primary;
// //                                 }}
// //                                 onBlur={(e) => {
// //                                     e.target.style.borderColor = theme.border;
// //                                 }}
// //                             />
// //                             <input
// //                                 style={styles.priceInput}
// //                                 type="number"
// //                                 placeholder="Menu ₹"
// //                                 value={v.actual_price || ''}
// //                                 onChange={(e) => {
// //                                     let nv = [...formData.variant];
// //                                     nv[i].actual_price = parseFloat(e.target.value) || 0;
// //                                     setFormData({...formData, variant: nv});
// //                                 }}
// //                                 onFocus={(e) => {
// //                                     e.target.style.borderColor = theme.primary;
// //                                 }}
// //                                 onBlur={(e) => {
// //                                     e.target.style.borderColor = theme.border;
// //                                 }}
// //                             />
// //                             <div style={styles.priceDisplay}>
// //                                 <div style={styles.priceLabel}>App Price</div>
// //                                 <div style={styles.priceValue}>
// //                                     ₹{calculateCustomerPrice(v.actual_price)}
// //                                 </div>
// //                             </div>
// //                             <button
// //                                 onClick={() => {
// //                                     let nv = formData.variant.filter((_, idx) => idx !== i);
// //                                     setFormData({...formData, variant: nv});
// //                                 }}
// //                                 style={styles.deleteButton}
// //                                 onMouseEnter={(e) => {
// //                                     e.currentTarget.style.background = `${theme.error}20`;
// //                                     e.currentTarget.style.transform = 'scale(1.1)';
// //                                 }}
// //                                 onMouseLeave={(e) => {
// //                                     e.currentTarget.style.background = 'none';
// //                                     e.currentTarget.style.transform = 'scale(1)';
// //                                 }}
// //                             >
// //                                 <Trash2 size={16} />
// //                             </button>
// //                         </div>
// //                     ))}
// //                 </div>
                
// //                 <div style={styles.footer}>
// //                     <button
// //                         onClick={onClose}
// //                         style={styles.cancelButton}
// //                         onMouseEnter={(e) => {
// //                             e.currentTarget.style.background = theme.border;
// //                         }}
// //                         onMouseLeave={(e) => {
// //                             e.currentTarget.style.background = theme.surfaceLighter;
// //                         }}
// //                     >
// //                         Cancel
// //                     </button>
// //                     <button
// //                         onClick={handleSave}
// //                         disabled={saving}
// //                         style={{
// //                             ...styles.saveButton,
// //                             opacity: saving ? 0.7 : 1,
// //                             cursor: saving ? 'not-allowed' : 'pointer',
// //                         }}
// //                         onMouseEnter={(e) => {
// //                             if (!saving) {
// //                                 e.currentTarget.style.filter = 'brightness(1.1)';
// //                                 e.currentTarget.style.transform = 'translateY(-1px)';
// //                             }
// //                         }}
// //                         onMouseLeave={(e) => {
// //                             e.currentTarget.style.filter = 'brightness(1)';
// //                             e.currentTarget.style.transform = 'translateY(0)';
// //                         }}
// //                     >
// //                         {saving ? (
// //                             <>⏳ Updating...</>
// //                         ) : (
// //                             <><Save size={16}/> Save Item</>
// //                         )}
// //                     </button>
// //                 </div>
// //             </div>

// //             {showImageFinder && (
// //                 <ImageSearchModal
// //                     isOpen={showImageFinder}
// //                     onClose={() => setShowImageFinder(false)}
// //                     query={formData.name}
// //                     onSelect={(img) => {
// //                         setFormData({...formData, pic1: img});
// //                         setShowImageFinder(false);
// //                     }}
// //                     theme={theme}
// //                     isDark={themeContext?.currentTheme === 'dark'}
// //                 />
// //             )}
// //         </div>
// //     );
// // };

// // export default EditItemModal;



// import React, { useState, useEffect } from 'react';
// import { postData, serverURL } from '../../../../services/Fetchnodeservices';
// import { X, Save, Sparkles, Trash2 } from 'lucide-react';
// import ImageSearchModal from './ImageSearchModal';

// const EditItemModal = ({ isOpen, onClose, item, designationId, onUpdate, ts }) => {
//     const [formData, setFormData] = useState(null);
//     const [saving, setSaving] = useState(false);
//     const [showImageFinder, setShowImageFinder] = useState(false);

//     useEffect(() => {
//         if (item) {
//             // Parse variants safely
//             let variants = [];
//             try {
//                 variants = Array.isArray(item.variant) ? item.variant : JSON.parse(item.variant || '[]');
//             } catch (e) {
//                 variants = [];
//             }

//             // 🔥 FIX: If actual_price is missing, set it to item_price_variant (treat as menu)
//             // This will show the correct menu price in the input field
//             const processed = variants.map(v => ({
//                 ...v,
//                 actual_price: v.actual_price || parseFloat(v.item_price_variant || v.price) || 0
//             }));

//             // Item-level fallback (if no variants, use requested_price or price)
//             let itemLevelMenu = parseFloat(item.requested_price) || 0;
//             if (!itemLevelMenu) {
//                 itemLevelMenu = parseFloat(item.price) || 0; // use price as menu if requested_price missing
//             }

//             setFormData({
//                 ...item,
//                 requested_price: itemLevelMenu,
//                 price: parseFloat(item.price) || 0,
//                 variant: processed
//             });
//         }
//     }, [item]);

//     // Customer price = menu * 1.2
//     const calculateCustomerPrice = (menuP) => {
//         const menu = parseFloat(menuP) || 0;
//         return Math.round(menu * 1.20);
//     };

//     const handleSave = async () => {
//         setSaving(true);
//         try {
//             // Process each variant: actual_price is menu, item_price_variant = menu * 1.2
//             const finalVariants = formData.variant.map(v => {
//                 const menuPrice = parseFloat(v.actual_price) || 0;
//                 const custPrice = calculateCustomerPrice(menuPrice);
//                 // return {
//                 //     ...v,
//                 //     actual_price: menuPrice,
//                 //     item_price_variant: custPrice,
//                 //     price: custPrice, // backward compatibility
//                 //     unit: (v.unit_value || "Price").toLowerCase(),
//                 //     is_available_variant: "yes"
//                 // };

//                 return {
//     ...v,
//     base_price: menuPrice,
//     actual_price: menuPrice,
//     item_price_variant: custPrice,
//     price: custPrice,
//     unit: (v.unit_value || "Price").toLowerCase(),
//     is_available_variant: "yes"
// }
//             });


//             // Item-level prices from first variant if exists
//             let itemRequestedPrice = 0;
//             let itemPrice = 0;
//             if (finalVariants.length > 0) {
//                 itemRequestedPrice = finalVariants[0].actual_price;
//                 itemPrice = finalVariants[0].item_price_variant;
//             } else {
//                 itemRequestedPrice = parseFloat(formData.requested_price) || 0;
//                 itemPrice = calculateCustomerPrice(itemRequestedPrice);
//             }

//             // const finalItem = {
//             //     ...formData,
//             //     variant: finalVariants,
//             //     requested_price: itemRequestedPrice,
//             //     price: itemPrice,
//             //     is_veg: formData.is_veg || 'yes'
//             // };

//             const finalItem = {
//     ...formData,
//     variant: finalVariants,

//     base_price: itemRequestedPrice,
//     requested_price: itemRequestedPrice,

//     price: itemPrice,

//     is_veg: formData.is_veg || "yes"
// };

//             console.log('Saving item:', finalItem);

//             const resp = await postData(`menu/update-menu/${designationId}/${item.product_id}`, finalItem, 'PUT');
//             if (resp.success) {
//                 onUpdate();
//                 onClose();
//             } else {
//                 alert('Update failed: ' + (resp.message || 'Unknown error'));
//             }
//         } catch (e) {
//             console.error('Save error:', e);
//             alert('Error: ' + e.message);
//         }
//         finally { setSaving(false); }
//     };

//     if (!isOpen || !formData) return null;

//     // Styles (using ts prop for theme)
//     const styles = {
//         overlay: {
//             position: 'fixed',
//             inset: 0,
//             background: 'rgba(0,0,0,0.85)',
//             zIndex: 10000,
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center'
//         },
//         modal: {
//             background: ts.surface,
//             width: '95%',
//             maxWidth: '500px',
//             borderRadius: '24px',
//             border: `1px solid ${ts.border}`,
//             color: ts.textPrimary,
//             overflow: 'hidden',
//             backgroundImage: ts.gradientCard
//         },
//         input: {
//             width: '100%',
//             padding: '12px',
//             borderRadius: '12px',
//             background: ts.background,
//             border: `1px solid ${ts.border}`,
//             color: ts.textPrimary,
//             marginBottom: '15px',
//             outline: 'none'
//         },
//         vRow: {
//             display: 'flex',
//             gap: '10px',
//             alignItems: 'center',
//             background: ts.surfaceLighter,
//             padding: '12px',
//             borderRadius: '15px',
//             marginBottom: '10px',
//             border: `1px solid ${ts.border}`
//         }
//     };

//     return (
//         <div style={styles.overlay}>
//             <div style={styles.modal}>
//                 <div style={{
//                     padding: '20px',
//                     borderBottom: `1px solid ${ts.border}`,
//                     display: 'flex',
//                     justifyContent: 'space-between'
//                 }}>
//                     <h3 style={{ margin: 0 }}>✏️ Edit Item</h3>
//                     <button onClick={onClose} style={{ background: 'none', border: 'none', color: ts.textMuted }}>
//                         <X />
//                     </button>
//                 </div>
//                 <div style={{ padding: '24px', maxHeight: '70vh', overflowY: 'auto' }}>
//                     <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
//                         <div style={{ textAlign: 'center' }}>
//                             <img
//                                 src={formData.pic1?.startsWith('http') ? formData.pic1 : `${serverURL}/uploads/${formData.pic1}`}
//                                 style={{ width: '100px', height: '100px', borderRadius: '16px', objectFit: 'cover' }}
//                                 onError={e => e.target.src = "https://via.placeholder.com/100"}
//                             />
//                             <button
//                                 onClick={() => setShowImageFinder(true)}
//                                 style={{
//                                     marginTop: '8px',
//                                     background: ts.primary,
//                                     color: 'black',
//                                     border: 'none',
//                                     padding: '5px 10px',
//                                     borderRadius: '8px',
//                                     fontSize: '10px',
//                                     fontWeight: 'bold',
//                                     cursor: 'pointer'
//                                 }}
//                             >
//                                 <Sparkles size={10}/> AI Search
//                             </button>
//                         </div>
//                         <div style={{ flex: 1 }}>
//                             <input
//                                 style={styles.input}
//                                 value={formData.name || ''}
//                                 onChange={e => setFormData({...formData, name: e.target.value})}
//                                 placeholder="Item Name"
//                             />
//                             <select
//                                 style={styles.input}
//                                 value={formData.is_veg || 'yes'}
//                                 onChange={e => setFormData({...formData, is_veg: e.target.value})}
//                             >
//                                 <option value="yes">Veg</option>
//                                 <option value="no">Non-Veg</option>
//                             </select>
//                         </div>
//                     </div>
//                     <textarea
//                         style={{ ...styles.input, height: '60px' }}
//                         value={formData.description || ''}
//                         onChange={e => setFormData({...formData, description: e.target.value})}
//                         placeholder="Description"
//                     />

//                     <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
//                         <label style={{ fontSize: '12px', fontWeight: 700 }}>💲 PRICING (MENU PRICE)</label>
//                         <button
//                             onClick={() => setFormData({
//                                 ...formData,
//                                 variant: [...formData.variant, { unit_value: '', actual_price: 0 }]
//                             })}
//                             style={{ color: ts.primary, background: 'none', border: 'none', fontSize: '12px', cursor: 'pointer' }}
//                         >
//                             + Add Price
//                         </button>
//                     </div>

//                     {formData.variant.map((v, i) => (
//                         <div key={i} style={styles.vRow}>
//                             <input
//                                 style={{ ...styles.input, marginBottom: 0, flex: 1.5 }}
//                                 placeholder="Unit (e.g. Half, Full)"
//                                 value={v.unit_value || ''}
//                                 onChange={e => {
//                                     let nv = [...formData.variant];
//                                     nv[i].unit_value = e.target.value;
//                                     setFormData({...formData, variant: nv});
//                                 }}
//                             />
//                             <input
//                                 style={{ ...styles.input, marginBottom: 0, flex: 1 }}
//                                 type="number"
//                                 placeholder="Menu ₹"
//                                 value={v.actual_price || ''}
//                                 onChange={e => {
//                                     let nv = [...formData.variant];
//                                     nv[i].actual_price = parseFloat(e.target.value) || 0;
//                                     setFormData({...formData, variant: nv});
//                                 }}
//                             />
//                             <div style={{ flex: 1, textAlign: 'right' }}>
//                                 <div style={{ fontSize: '10px', color: ts.textMuted }}>App Price</div>
//                                 <div style={{ color: ts.success, fontWeight: 700 }}>
//                                     ₹{calculateCustomerPrice(v.actual_price)}
//                                 </div>
//                             </div>
//                             <button
//                                 onClick={() => {
//                                     let nv = formData.variant.filter((_, idx) => idx !== i);
//                                     setFormData({...formData, variant: nv});
//                                 }}
//                                 style={{ color: ts.error, background: 'none', border: 'none' }}
//                             >
//                                 <Trash2 size={16} />
//                             </button>
//                         </div>
//                     ))}
//                 </div>
//                 <div style={{
//                     padding: '20px',
//                     borderTop: `1px solid ${ts.border}`,
//                     display: 'flex',
//                     gap: '10px'
//                 }}>
//                     <button
//                         onClick={onClose}
//                         style={{
//                             flex: 1,
//                             padding: '12px',
//                             borderRadius: '12px',
//                             border: `1px solid ${ts.border}`,
//                             background: 'none',
//                             color: ts.textSecondary
//                         }}
//                     >
//                         Cancel
//                     </button>
//                     <button
//                         onClick={handleSave}
//                         disabled={saving}
//                         style={{
//                             flex: 2,
//                             padding: '12px',
//                             borderRadius: '12px',
//                             background: ts.primary,
//                             color: 'black',
//                             border: 'none',
//                             fontWeight: 700
//                         }}
//                     >
//                         {saving ? "Updating..." : "💾 Save Item"}
//                     </button>
//                 </div>
//             </div>

//             {showImageFinder && (
//                 <ImageSearchModal
//                     isOpen={showImageFinder}
//                     onClose={() => setShowImageFinder(false)}
//                     query={formData.name}
//                     onSelect={img => {
//                         setFormData({...formData, pic1: img});
//                         setShowImageFinder(false);
//                     }}
//                 />
//             )}
//         </div>
//     );
// };

// export default EditItemModal;

import React, { useContext, useEffect, useState } from "react";
import { X, Save, Sparkles, Trash2 } from "lucide-react";

import {
  postData,
  serverURL,
} from "../../../../services/Fetchnodeservices";
import { ThemeContext } from "../../../../context/ThemeContext";
import ImageSearchModal from "./ImageSearchModal";

const EditItemModal = ({
  isOpen,
  onClose,
  item,
  designationId,
  designation_id,
  onUpdate,
  onSuccess,
}) => {
  const themeContext = useContext(ThemeContext);
  const isDark = themeContext?.currentTheme === "dark";

  const fallbackTheme = {
    background: isDark ? "#0f172a" : "#f8fafc",
    surface: isDark ? "#1e293b" : "#ffffff",
    surfaceLighter: isDark ? "#334155" : "#f1f5f9",
    border: isDark ? "#475569" : "#e2e8f0",
    textPrimary: isDark ? "#f8fafc" : "#0f172a",
    textSecondary: isDark ? "#cbd5e1" : "#334155",
    textMuted: isDark ? "#94a3b8" : "#64748b",
    primary: "#6366f1",
    primaryLight: "rgba(99, 102, 241, 0.15)",
    primaryGradient: "linear-gradient(135deg, #6366f1, #8b5cf6)",
  };

  const brandTheme = themeContext?.theme || fallbackTheme;

  const ts = {
    background: brandTheme.background || fallbackTheme.background,
    surface: brandTheme.surface || fallbackTheme.surface,
    surfaceLighter:
      brandTheme.surfaceLighter ||
      (isDark ? "#334155" : "#f1f5f9"),
    border: brandTheme.border || fallbackTheme.border,
    textPrimary: brandTheme.textPrimary || fallbackTheme.textPrimary,
    textSecondary: brandTheme.textSecondary || fallbackTheme.textSecondary,
    textMuted: brandTheme.textMuted || fallbackTheme.textMuted,
    primary: brandTheme.primary || fallbackTheme.primary,
    primaryLight: brandTheme.primaryLight || fallbackTheme.primaryLight,
    success: brandTheme.success || "#10b981",
    error: brandTheme.error || "#ef4444",
    gradient:
      brandTheme.primaryGradient ||
      `linear-gradient(135deg, ${brandTheme.primary || fallbackTheme.primary}, ${
        brandTheme.primaryDark || brandTheme.primary || fallbackTheme.primary
      })`,
  };

  const activeDesignationId = designationId || designation_id;
  const handleUpdate = onUpdate || onSuccess || (() => {});

  const [formData, setFormData] = useState(null);
  const [saving, setSaving] = useState(false);
  const [showImageFinder, setShowImageFinder] = useState(false);

//   useEffect(() => {
//     if (!item) return;

//     let variants = [];

//     try {
//       variants = Array.isArray(item.variant)
//         ? item.variant
//         : JSON.parse(item.variant || "[]");
//     } catch {
//       variants = [];
//     }

//     const processedVariants = variants.map((variant) => ({
//       ...variant,
//       actual_price:
//         variant.actual_price ||
//         parseFloat(variant.base_price) ||
//         parseFloat(variant.item_price_variant || variant.price) ||
//         0,
//     }));

//     let itemLevelMenuPrice =
//       parseFloat(item.base_price) ||
//       parseFloat(item.requested_price) ||
//       0;

//     if (!itemLevelMenuPrice) {
//       itemLevelMenuPrice = parseFloat(item.price) || 0;
//     }

//     setFormData({
//       ...item,
//       base_price: itemLevelMenuPrice,
//       requested_price: itemLevelMenuPrice,
//       price: parseFloat(item.price) || 0,
//       variant: processedVariants,
//     });
//   }, [item]);


useEffect(() => {
  if (!item) return;
  setSaving(false);

  let variants = [];

  try {
    variants = Array.isArray(item.variant)
      ? item.variant
      : JSON.parse(item.variant || "[]");
  } catch {
    variants = [];
  }

  let itemLevelMenuPrice =
    parseFloat(item.base_price) ||
    parseFloat(item.requested_price) ||
    0;

  // Old data fallback: agar sirf customer price saved hai.
  if (!itemLevelMenuPrice && item.price) {
    itemLevelMenuPrice = Math.round(parseFloat(item.price) / 1.2);
  }

  // const processedVariants = variants.map((variant) => ({
  //   ...variant,
  //   actual_price:
  //     parseFloat(variant.actual_price) ||
  //     parseFloat(variant.base_price) ||
  //     parseFloat(variant.requested_price) ||
  //     0,
  // }));


  const processedVariants = variants.map((variant) => {
  const actualPrice =
    parseFloat(variant.actual_price) ||
    parseFloat(variant.base_price) ||
    parseFloat(variant.requested_price) ||
    0;

  // Agar actual/menu price available nahi hai,
  // to customer/app price se menu price nikalo.
  const customerPrice =
    parseFloat(variant.item_price_variant) ||
    parseFloat(variant.price) ||
    0;

  const menuPrice =
    actualPrice > 0
      ? actualPrice
      : customerPrice > 0
        ? Math.round(customerPrice / 1.2)
        : 0;

  return {
    ...variant,

    // Edit box mein actual MENU PRICE dikhana hai
    actual_price: menuPrice,

    // Base/menu price bhi maintain karo
    base_price: menuPrice,
  };
});
  // IMPORTANT:
  // Agar item ke variants nahi hain, ek "Regular" price row banao.
  // Ab har item ka price Edit modal mein dikhai aur edit hoga.
  const editableVariants =
    processedVariants.length > 0
      ? processedVariants
      : [
          {
            unit_value: "Regular",
            actual_price: itemLevelMenuPrice,
            base_price: itemLevelMenuPrice,
          },
        ];

  const productId = item.product_id || item.id;

setFormData({
  ...item,
  product_id: productId,
  base_price: itemLevelMenuPrice,
  requested_price: itemLevelMenuPrice,
  price: parseFloat(item.price) || 0,
  variant: editableVariants,
});
}, [item]);
  const calculateCustomerPrice = (menuPrice) => {
    const menu = parseFloat(menuPrice) || 0;
    return Math.round(menu * 1.2);
  };

  const updateVariant = (variantIndex, changes) => {
    setFormData((previous) => ({
      ...previous,
      variant: previous.variant.map((variant, index) =>
        index === variantIndex
          ? { ...variant, ...changes }
          : variant
      ),
    }));
  };

  // const handleSave = async () => {
  //   if (!formData || !item?.product_id || !activeDesignationId) return;

  //   setSaving(true);

  //   try {
  //     const finalVariants = (formData.variant || []).map((variant) => {
  //       const menuPrice = parseFloat(variant.actual_price) || 0;
  //       const customerPrice = calculateCustomerPrice(menuPrice);

  //       return {
  //         ...variant,
  //         base_price: menuPrice,
  //         actual_price: menuPrice,
  //         item_price_variant: customerPrice,
  //         price: customerPrice,
  //         unit: (variant.unit_value || "Price").toLowerCase(),
  //         is_available_variant: "yes",
  //       };
  //     });

  //     let itemRequestedPrice = 0;
  //     let itemPrice = 0;

  //     if (finalVariants.length > 0) {
  //       itemRequestedPrice = finalVariants[0].actual_price;
  //       itemPrice = finalVariants[0].item_price_variant;
  //     } else {
  //       itemRequestedPrice =
  //         parseFloat(formData.base_price) ||
  //         parseFloat(formData.requested_price) ||
  //         0;

  //       itemPrice = calculateCustomerPrice(itemRequestedPrice);
  //     }

  //     const finalItem = {
  //       ...formData,
  //       variant: finalVariants,
  //       base_price: itemRequestedPrice,
  //       requested_price: itemRequestedPrice,
  //       price: itemPrice,
  //       is_veg: formData.is_veg || "yes",
  //     };

  //     const response = await postData(
  //       `menu/update-menu/${activeDesignationId}/${item.product_id}`,
  //       finalItem,
  //       "PUT"
  //     );

  //     if (response?.success) {
  //       handleUpdate();
  //       onClose();
  //     } else {
  //       alert(`Update failed: ${response?.message || "Unknown error"}`);
  //     }
  //   } catch (error) {
  //     console.error("Save error:", error);
  //     alert(`Error: ${error.message}`);
  //   } finally {
  //     setSaving(false);
  //   }
  // };


const handleSave = async () => {
  // const productId = item?.product_id || item?.id;
  const productId = item?.product_id || item?.central_product_id;
  const restaurantId = activeDesignationId;

  console.log("🔥 SAVE CLICKED");
  console.log("📦 item:", item);
  console.log("🆔 productId:", productId);
  console.log("🏪 designationId:", restaurantId);
  console.log("📋 formData:", formData);

  if (!formData) {
    alert("Form data missing");
    return;
  }

  if (!productId) {
    alert("Product ID missing");
    return;
  }

  if (!restaurantId) {
    alert("Restaurant ID missing");
    return;
  }

  setSaving(true);

  try {
    const finalVariants = (formData.variant || []).map((variant) => {
      const menuPrice = parseFloat(variant.actual_price) || 0;
      const customerPrice = calculateCustomerPrice(menuPrice);

      return {
        ...variant,
        base_price: menuPrice,
        actual_price: menuPrice,
        item_price_variant: customerPrice,
        price: customerPrice,
        unit: (variant.unit_value || "Price").toLowerCase(),
        is_available_variant: "yes",
      };
    });

    let itemRequestedPrice = 0;
    let itemPrice = 0;

    if (finalVariants.length > 0) {
      itemRequestedPrice = finalVariants[0].actual_price;
      itemPrice = finalVariants[0].item_price_variant;
    } else {
      itemRequestedPrice =
        parseFloat(formData.base_price) ||
        parseFloat(formData.requested_price) ||
        0;

      itemPrice = calculateCustomerPrice(itemRequestedPrice);
    }

    // const finalItem = {
    //   ...formData,
    //   product_id: productId,
    //   variant: finalVariants,
    //   base_price: itemRequestedPrice,
    //   requested_price: itemRequestedPrice,
    //   price: itemPrice,
    //   is_veg: formData.is_veg || "yes",
    // };

    const finalItem = {
  ...formData,

  // IMPORTANT:
  // central_product_id ko central hi rehne do
  product_id: item?.product_id || null,

  central_product_id:
    item?.central_product_id || formData?.central_product_id || null,

  variant: finalVariants,
  base_price: itemRequestedPrice,
  requested_price: itemRequestedPrice,
  price: itemPrice,
  is_veg: formData.is_veg || "yes",
};

    console.log("🚀 UPDATE API:", {
      restaurantId,
      productId,
      finalItem,
    });

    const response = await postData(
      `menu/update-menu/${restaurantId}/${productId}`,
      finalItem,
      "PUT"
    );

    console.log("✅ UPDATE RESPONSE:", response);

    if (response?.success) {
      handleUpdate();
      onClose();
    } else {
      alert(
        `Update failed: ${response?.message || "Unknown error"}`
      );
    }
  } catch (error) {
    console.error("❌ Save error:", error);
    alert(`Error: ${error.message}`);
  } finally {
    setSaving(false);
  }
};

  const styles = {
    overlay: {
      position: "fixed",
      inset: 0,
      background: "rgba(0, 0, 0, 0.72)",
      backdropFilter: "blur(5px)",
      zIndex: 10000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "20px",
    },
    modal: {
      background: ts.surface,
      width: "100%",
      maxWidth: "500px",
      borderRadius: "24px",
      border: `1px solid ${ts.border}`,
      color: ts.textPrimary,
      overflow: "hidden",
      boxShadow: "0 20px 40px rgba(0, 0, 0, 0.30)",
      maxHeight: "90vh",
      display: "flex",
      flexDirection: "column",
    },
    header: {
      padding: "20px",
      borderBottom: `1px solid ${ts.border}`,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      background: ts.surfaceLighter,
    },
    body: {
      padding: "24px",
      overflowY: "auto",
      flex: 1,
    },
    input: {
      width: "100%",
      boxSizing: "border-box",
      padding: "12px",
      borderRadius: "12px",
      background: ts.background,
      border: `1px solid ${ts.border}`,
      color: ts.textPrimary,
      marginBottom: "15px",
      outline: "none",
      fontSize: "14px",
    },
    textarea: {
      width: "100%",
      boxSizing: "border-box",
      padding: "12px",
      borderRadius: "12px",
      background: ts.background,
      border: `1px solid ${ts.border}`,
      color: ts.textPrimary,
      marginBottom: "15px",
      outline: "none",
      fontSize: "14px",
      resize: "vertical",
      minHeight: "70px",
      fontFamily: "inherit",
    },
    select: {
      width: "100%",
      boxSizing: "border-box",
      padding: "12px",
      borderRadius: "12px",
      background: ts.background,
      border: `1px solid ${ts.border}`,
      color: ts.textPrimary,
      marginBottom: "15px",
      outline: "none",
      fontSize: "14px",
      cursor: "pointer",
    },
    vRow: {
      display: "flex",
      gap: "10px",
      alignItems: "center",
      background: ts.surfaceLighter,
      padding: "12px",
      borderRadius: "15px",
      marginBottom: "10px",
      border: `1px solid ${ts.border}`,
    },
    footer: {
      padding: "20px",
      borderTop: `1px solid ${ts.border}`,
      display: "flex",
      gap: "10px",
      background: ts.surfaceLighter,
    },
  };

  if (!isOpen || !formData) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(event) => event.stopPropagation()}>
        <div style={styles.header}>
          <h3
            style={{
              margin: 0,
              fontSize: "20px",
              fontWeight: 700,
              color: ts.textPrimary,
            }}
          >
            ✏️ Edit Item
          </h3>

          <button
            type="button"
            onClick={onClose}
            style={{
              background: ts.background,
              border: "none",
              color: ts.textMuted,
              cursor: "pointer",
              padding: "8px",
              borderRadius: "8px",
              display: "flex",
            }}
          >
            <X size={18} />
          </button>
        </div>

        <div style={styles.body}>
          <div
            style={{
              display: "flex",
              gap: "20px",
              marginBottom: "20px",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <img
                src={
                  formData.pic1?.startsWith("http")
                    ? formData.pic1
                    : `${serverURL}/uploads/${formData.pic1}`
                }
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "16px",
                  objectFit: "cover",
                  border: `2px solid ${ts.border}`,
                }}
                alt="Item"
                onError={(event) => {
                  event.currentTarget.src =
                    "https://via.placeholder.com/100?text=No+Image";
                }}
              />

              <button
                type="button"
                onClick={() => setShowImageFinder(true)}
                style={{
                  marginTop: "8px",
                  background: ts.gradient,
                  color: "#ffffff",
                  border: "none",
                  padding: "6px 12px",
                  borderRadius: "8px",
                  fontSize: "11px",
                  fontWeight: 600,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <Sparkles size={12} /> AI Search
              </button>
            </div>

            <div style={{ flex: 1 }}>
              <input
                style={styles.input}
                value={formData.name || ""}
                onChange={(event) =>
                  setFormData({
                    ...formData,
                    name: event.target.value,
                  })
                }
                placeholder="Item Name"
              />

              <select
                style={styles.select}
                value={formData.is_veg || "yes"}
                onChange={(event) =>
                  setFormData({
                    ...formData,
                    is_veg: event.target.value,
                  })
                }
              >
                <option value="yes">🥬 Veg</option>
                <option value="no">🍖 Non-Veg</option>
              </select>
            </div>
          </div>

          <textarea
            style={styles.textarea}
            value={formData.description || ""}
            onChange={(event) =>
              setFormData({
                ...formData,
                description: event.target.value,
              })
            }
            placeholder="Description"
            rows="3"
          />

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <label
              style={{
                fontSize: "12px",
                fontWeight: 700,
                color: ts.textPrimary,
              }}
            >
              💲 PRICING (MENU PRICE)
            </label>

            <button
              type="button"
              onClick={() =>
                setFormData({
                  ...formData,
                  variant: [
                    ...(formData.variant || []),
                    {
                      unit_value: "",
                      actual_price: 0,
                      base_price: 0,
                    },
                  ],
                })
              }
              style={{
                color: ts.primary,
                background: "none",
                border: "none",
                fontSize: "12px",
                cursor: "pointer",
                fontWeight: 700,
              }}
            >
              + Add Price
            </button>
          </div>

          {(formData.variant || []).map((variant, index) => (
            <div key={index} style={styles.vRow}>
              <input
                style={{
                  ...styles.input,
                  marginBottom: 0,
                  flex: 1.5,
                }}
                placeholder="Unit (Half, Full)"
                value={variant.unit_value || ""}
                onChange={(event) =>
                  updateVariant(index, {
                    unit_value: event.target.value,
                  })
                }
              />

              <input
                style={{
                  ...styles.input,
                  marginBottom: 0,
                  flex: 1,
                }}
                type="number"
                placeholder="Menu ₹"
                value={variant.actual_price || ""}
                onChange={(event) =>
                  updateVariant(index, {
                    actual_price: parseFloat(event.target.value) || 0,
                    base_price: parseFloat(event.target.value) || 0,
                  })
                }
              />

              <div style={{ flex: 1, textAlign: "right" }}>
                <div style={{ fontSize: "10px", color: ts.textMuted }}>
                  App Price
                </div>

                <div style={{ color: ts.success, fontWeight: 700 }}>
                  ₹{calculateCustomerPrice(variant.actual_price)}
                </div>
              </div>

              <button
                type="button"
                onClick={() =>
                  setFormData({
                    ...formData,
                    variant: formData.variant.filter(
                      (_, variantIndex) => variantIndex !== index
                    ),
                  })
                }
                style={{
                  color: ts.error,
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  display: "flex",
                }}
              >
                <Trash2 size={16} />
              </button>
            </div>
          ))}
        </div>

        <div style={styles.footer}>
          <button
            type="button"
            onClick={onClose}
            style={{
              flex: 1,
              padding: "12px",
              borderRadius: "12px",
              border: `1px solid ${ts.border}`,
              background: ts.background,
              color: ts.textSecondary,
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={handleSave}
            disabled={saving}
            style={{
              flex: 2,
              padding: "12px",
              borderRadius: "12px",
              background: ts.gradient,
              color: "#ffffff",
              border: "none",
              fontWeight: 700,
              cursor: saving ? "not-allowed" : "pointer",
              opacity: saving ? 0.7 : 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            {saving ? "⏳ Updating..." : <><Save size={16} /> Save Item</>}
          </button>
        </div>
      </div>

      {showImageFinder && (
        <div onClick={(event) => event.stopPropagation()}>
          <ImageSearchModal
            isOpen={showImageFinder}
            onClose={() => setShowImageFinder(false)}
            query={formData.name}
            onSelect={(imageUrl) => {
              setFormData({
                ...formData,
                pic1: imageUrl,
              });
              setShowImageFinder(false);
            }}
            theme={brandTheme}
            isDark={isDark}
          />
        </div>
      )}
    </div>
  );
};

export default EditItemModal;